import Vue from 'vue';
import {mapState,mapActions} from 'vuex';
import $ from 'jquery' ;
import { Toast } from 'vant';
import http from '../../utils/config';
import Axios from 'axios';
let Base64 = require('js-base64').Base64;
import { PullRefresh } from 'vant';

Vue.use(PullRefresh);
export default {
  name: 'smart',
  data() {
    return {
      list:[{
        question:"",
        result:"",
        type:''
      }],
      cont:'',
      code:'',
      openId:"",
      count: [],
      isLoading: true,
      issend:true,
      page:0,
      num:1,
      rotDetail:{}
    };

  },
  updated(){
    // 聊天定位到底部
    if(this.issend==true){
      let ele = document.querySelector(".cont");
      $(".cont").scrollTop(ele.scrollHeight);

    }

  },
  created() {
    if(this.getUrlParam('productCode')){
      localStorage.setItem('productCode',this.getUrlParam('productCode'))
    }
    this.getSet();
    this.getCode1();





  },
  methods: {

    ...mapActions('smart', ['getReult','getPull']),
    toHistory(){
      this.$router.push({name:'History'})
    },
    tofeed(){
      this.$router.push({name:'feedBack'})
    },
    onRefresh() {
      this.issend=false
      this.isLoading = false;
      this.getPull({
        openId:Base64.encode(this.openId),
        // this.count[0]
        rawId:this.num,
        pageSize:'4'
      }).then(res=>{
        if(res.code==200){
          this.num++
        var resList=res.data.records
        for(let i=0;i<resList.length;i++){
          resList[i].content=JSON.parse(resList[i].content)
        }
        this.count=resList.concat(this.count);
        }
      })
    },
       // 授权登录
    getCode1(){ // 非静默授权，第一次有弹框
    const self=this;
    var that=this
    console.log(self.rotDetail.standby3)
        const code = this.getUrlParam('code'); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId


          const local = window.location.href
        if (code == null || code == '' ||code==undefined) {
          var api2=http+'system/user/selectChatMsg'
          Axios({
            method:'post',
            url: api2,
            params:{
              productCode:localStorage.getItem('productCode')
            }
          }).then(res=>{
            if(res.data.code==200){
              localStorage.setItem("appid",res.data.data.standby3)
              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+localStorage.getItem("appid")+'&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'

              return
            }
          })
        }
        else
        {
          self.code=code;
          var api1=http+'system/user/selectChatCode'
          Axios({
            method:'post',
            url: api1,
            params:{
              code:self.code,
              pcode1:this.getUrlParam('productCode')
            }
        }).then(res=>{
            if(res.data.code===200){
            self.openId=res.data.openId;
            localStorage.setItem("openId",res.data.openId)
            }else{
              //Toast(res.data.msg)

            }
        })
        }
      },
      getUrlParam: function (name) {
        var reg=new RegExp('(^|&)'+name+'=([^&]*)(&|$)')
        var r=window.location.search.substr(1).match(reg)
        if(r!=null) return unescape(r[2])
        return null
      },
    back() {
      this.$router.go(-1);
    },
    sendOut(Title){
      var self=this
      if(Title==''){
        Toast('请先输入询问内容')
      }else if(Title.length>255){
        Toast('请输入255位字符以内的问题')
      }else{
        this.issend=true
        this.getReult({
          question:Base64.encode(Title),
          pcode1:this.getUrlParam('productCode'),
          openId:Base64.encode(this.openId),

        }).then(res=>{
          this.page=res.data.rawNo;
          var theCont=JSON.parse(res.data.content)
          if(theCont.Messages[0].Type=='Knowledge'){
            var obj={
              question:Title,
              result:theCont.Messages[0].Knowledge.Content.replace(/<link[^>]+>/g,""),//.replace(/<[^>]+>/g,"")
              type:theCont.Messages[0].Type,

            }
          }else if(theCont.Messages[0].Type=='Recommend'){
            var obj={
              question:Title,
              result:theCont.Messages[0].Recommends,
              type:theCont.Messages[0].Type
            }
          }else if(theCont.Messages[0].Type=='Text'){
            var obj={
              question:Title,
              result:this.rotDetail.standby2,
              type:theCont.Messages[0].Type
            }
          }
          this.list.push(obj);
          this.cont="";
        })
      }





    },

    getSet(){///system/user/selectChatMsg
      var that=this
      var api2=http+'system/user/selectChatMsg'
      Axios({
        method:'post',
        url: api2,
        params:{
          productCode:localStorage.getItem('productCode')
        }
    }).then(res=>{
      if(res.data.code==200){
        that.rotDetail=res.data.data
        that.rotDetail.rebotGreetings=JSON.parse(that.rotDetail.rebotGreetings)
      }
    })
    }
  },

};
